module.exports = __webpack_public_path__ + "img/logo-onesait@2x.aa668adb.png";